__turbopack_context__.v({
  "card": "Intro-module-scss-module__KmpRZW__card",
  "cardInner": "Intro-module-scss-module__KmpRZW__cardInner",
  "cards": "Intro-module-scss-module__KmpRZW__cards",
  "copy": "Intro-module-scss-module__KmpRZW__copy",
  "fade-in": "Intro-module-scss-module__KmpRZW__fade-in",
  "fan-stories": "Intro-module-scss-module__KmpRZW__fan-stories",
  "header": "Intro-module-scss-module__KmpRZW__header",
  "image": "Intro-module-scss-module__KmpRZW__image",
  "inner": "Intro-module-scss-module__KmpRZW__inner",
  "lockup": "Intro-module-scss-module__KmpRZW__lockup",
  "our-journey": "Intro-module-scss-module__KmpRZW__our-journey",
  "root": "Intro-module-scss-module__KmpRZW__root",
  "the-morning-star": "Intro-module-scss-module__KmpRZW__the-morning-star",
  "title": "Intro-module-scss-module__KmpRZW__title",
});
